import React from "react";
import { TourContent } from "components/tours/tour-content";
import { browserHistory } from "react-router";

export const getTourSteps = (props) => {
  switch (props.tourName) {
    case "overview":
      return overviewSteps(props);
    case "upload":
      return uploadSteps(props);
    case "manual":
      return manualSteps(props);
    case "documents":
      return documentsSteps(props);
    case "automate":
      return automateSteps(props);
    default:
      return null;
  }
};

/* eslint react/prop-types: 0 */
const overviewSteps = (props) => [
  {
    selector: ".overview1",
    content: ({ goTo }) => (
      <TourContent
        content="From the dashboard you can view important account information such as usage and totals"
        onClick={ () => goTo(1) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".overview2",
    content: ({ goTo }) => (
      <TourContent
        content={ `This is where you can upload your documents, check the document processing queue,
          manually process documents & get more information about the different types of document submission` }
        onClick={ () => goTo(2) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".overview3",
    content: ({ goTo }) => (
      <TourContent
        content="From here you can view, search, edit, code, export all your documents and more!"
        onClick={ () => goTo(3) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".overview4",
    content: ({ goTo }) => (
      <TourContent
        content="From here you can manage all of your vendors, categories and set up automatic rule creation for them!"
        onClick={ () => goTo(4) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".overview5",
    content: ({ goTo }) => (
      <TourContent
        content="View and generate your reports!"
        onClick={ () => goTo(5) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".overview6",
    content: ({ goTo }) => (
      <TourContent
        content="This button opens the account menu"
        onClick={ () => goTo(6) }
      />
    ),
    position: "bottom"
  },
  {
    action: () => props.onStartSettingsMode(),
    selector: ".overview7",
    content: ({ goTo }) => (
      <TourContent
        content={ `Here you can access all of your account and user settings, envelopes, support,
          logout function and the old UI` }
        last
        onClick={ () => { goTo(0); props.onEndTour(); props.onEndSettingsMode(); } }
      />
    ),
    position: "bottom"
  }
];

const uploadSteps = (props) => [
  {
    selector: ".upload1",
    content: ({ goTo }) => (
      <TourContent
        content="Go here to upload and manage processing documents"
        onClick={ () => { browserHistory.push(`/accounts/${props.accountSlug.slug}/upload`); goTo(1); } }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".upload2",
    content: ({ goTo }) => (
      <TourContent
        content={ `On this screen we can upload documents directly as well as get
          information about the other types of document submission` }
        onClick={ () => goTo(2) }
      />
    ),
    position: "center"
  },
  {
    selector: ".upload3",
    content: ({ goTo }) => (
      <TourContent
        content="To upload directly via the web, simply click this button and select documents from your computer!"
        onClick={ () => goTo(3) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".upload4",
    content: ({ goTo }) => (
      <TourContent
        content="Otherwise you can download our mobile app to take pictures of documents to upload"
        onClick={ () => goTo(4) }
      />
    ),
    position: "top"
  },
  {
    selector: ".upload5",
    content: ({ goTo }) => (
      <TourContent
        content="Or via our dropbox integration"
        onClick={ () => goTo(5) }
      />
    ),
    position: "top"
  },
  {
    selector: ".upload6",
    content: ({ goTo }) => (
      <TourContent
        content="With one of our magic envelopes (depending on the plan), or via regular post."
        onClick={ () => goTo(6) }
      />
    ),
    position: "top"
  },
  {
    selector: ".upload7",
    content: ({ goTo }) => (
      <TourContent
        content="And finally, you can upload through your Squirrelstreet submission email address"
        last
        onClick={ () => {
          browserHistory.push(`/accounts/${props.accountSlug.slug}/dashboard`);
          goTo(0);
          props.onEndTour();
        } }
      />
    ),
    position: "top"
  }
];

const manualSteps = (props) => [
  {
    selector: ".manual1",
    content: ({ goTo }) => (
      <TourContent
        content="If you would like to process your documents manually, you can do this from the submit page"
        onClick={ () => { browserHistory.push(`/accounts/${props.accountSlug.slug}/upload`); goTo(1); } }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".manual2",
    content: ({ goTo }) => (
      <TourContent
        content={ `On this screen we can upload documents directly as well as get
          information about the other types of document submission` }
        onClick={ () => goTo(2) }
      />
    ),
    position: "center"
  },
  {
    selector: ".manual3",
    content: ({ goTo }) => (
      <TourContent
        content={ `From here, we can navigate to the 'Awaiting Processing' tab,
            where we can manually process our documents` }
        onClick={ () => { browserHistory.push(`/accounts/${props.accountSlug.slug}/awaiting-digital`); goTo(3); } }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".manual4",
    content: ({ goTo }) => (
      <TourContent
        content="This is the document queue, where you can view all the documents that are awaiting processing"
        onClick={ () => goTo(4) }
      />
    ),
    position: "right"
  },
  {
    selector: ".manual5",
    content: ({ goTo }) => (
      <TourContent
        content="Here we can see the selected document from the document queue"
        onClick={ () => goTo(5) }
      />
    ),
    position: "left"
  },
  {
    selector: ".manual6",
    content: ({ goTo }) => (
      <TourContent
        content={ `Here we can cancel automatic processing, and process the document manually.
          We can then add all the necessary details for this document,
          and press save to have the document appear in the documents grid` }
        onClick={ () => goTo(6) }
      />
    ),
    position: "right"
  },
  {
    selector: ".manual7",
    content: ({ goTo }) => (
      <TourContent
        content={ `We can set the default processing mode for all the documents in the list!
          Simply click this button to toggle automatic and manual processing as default` }
        last
        onClick={ () => {
          browserHistory.push(`/accounts/${props.accountSlug.slug}/dashboard`);
          goTo(0);
          props.onEndTour();
        } }
      />
    ),
    position: "left"
  }
];

const documentsSteps = (props) => [
  {
    selector: ".documents1",
    content: ({ goTo }) => (
      <TourContent
        content="Let's go to the View and Export page!"
        onClick={ () => {
          browserHistory.push(`/accounts/${props.accountSlug.slug}/documents/all`);
          goTo(1);
        } }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".documents2",
    content: ({ goTo }) => (
      <TourContent
        content={ `From this page we can view all the documents that have been uploaded into the account,
          as well as perform actions on them such as editing, filtering and exporting.` }
        onClick={ () => { props.onFocusDocument(props.documents[0], { top: 0 }); goTo(2); } }
      />
    ),
    position: "center"
  },
  {
    selector: ".documents3",
    content: ({ goTo }) => (
      <TourContent
        content={ `If we select a document in the grid, we can see all the editable document fields.
          This includes inline editing for receipts (depending on the columns that have been selected).` }
        onClick={ () => goTo(3) }
      />
    ),
    position: "bottom"
  },
  {
    selector: ".documents4",
    content: ({ goTo }) => (
      <TourContent
        content="And we can see the actual uploaded document here."
        onClick={ () => goTo(4) }
      />
    ),
    position: "left"
  },
  {
    selector: ".documents5",
    content: ({ goTo }) => (
      <TourContent
        content={ `You can perform various actions such as editing visible columns,
            filtering documents and exporting from here. If you select some documents,
            extra document functions will appear here too` }
        last
        onClick={ () => {
          goTo(0);
          props.onEndTour();
          browserHistory.push(`/accounts/${props.accountSlug.slug}/dashboard`);
        } }
      />
    ),
    position: "bottom"
  }
];

const automateSteps = (props) => [
  {
    selector: ".automate1",
    content: ({ goTo }) => (
      <TourContent
        content="Let's go to the automation page!"
        onClick={ () => {
          browserHistory.push(`/accounts/${props.accountSlug.slug}/automate/manage-categories`);
          goTo(1);
        } }
      />
    ),
    position: "bottom"
  },
  {
    selector: "body",
    content: ({ goTo }) => (
      <TourContent
        content={ `From here we can manage our account categories.
          We can perform actions such as adding and removing categories,
          and adding or removing categorization rules on a by category basis` }
        onClick={ () => goTo(2) }
      />
    ),
    position: "center"
  },
  {
    selector: ".automate2",
    content: ({ goTo }) => (
      <TourContent
        content="From here we can navigate to the Manage Vendors page"
        onClick={ () => {
          browserHistory.push(`/accounts/${props.accountSlug.slug}/automate/manage-vendors`);
          goTo(3);
        } }
      />
    ),
    position: "bottom"
  },
  {
    selector: "body",
    content: ({ goTo }) => (
      <TourContent
        content={ `From here we can manage our account vendors; we can merge duplicate vendors, and
          add and remove categorization rules on a by vendor basis.` }
        onClick={ () => {
          goTo(0);
          props.onEndTour();
          browserHistory.push(`/accounts/${props.accountSlug.slug}/dashboard`);
        } }
      />
    ),
    position: "center"
  }
];



// WEBPACK FOOTER //
// ./src/js/components/tours/tour-steps.jsx